// extracted by mini-css-extract-plugin
export default {"tableHeader":"column-labels-table-container_tableHeader__J-Vlg","tableHeaderCell":"column-labels-table-container_tableHeaderCell__9AhCB"};